import { AlertService, DateService } from "@standard/services";
import NoRecordsFound from "customComponents/NoRecordsFound";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import FileInput from "@standard/components/FileInput";

const AssetBox = ({ value, disabled, onFileDelete, onFileRollback }) => {
  let btnAction;
  let link = (
    <a href={value.assetPreview.url} target="_blank">
      {value.assetPreview.name}
    </a>
  );

  if (disabled === false) {
    if (value.isDelete !== true) {
      btnAction = (
        <i
          onClick={(e) => {
            AlertService.confirm("Do you want to delete this file ?").then(
              (res) => {
                if (res === true) onFileDelete(value._id);
              }
            );
          }}
          className="fa fa-close text-danger btn btn-link"
        ></i>
      );
    } else {
      btnAction = (
        <i
          onClick={(e) => {
            onFileRollback(value._id);
          }}
          className="fa fa-undo text-primary btn btn-link"
        ></i>
      );
    }
  }

  if (value.isDelete) {
    link = <del>{link}</del>;
  }

  return (
    <li>
      <i className="fa fa-paperclip" aria-hidden="true"></i>&nbsp;
      {link}
      &nbsp;
      {btnAction}
      <br />
      <small className="text-muted">
        by {value.uploadedBy} at{" "}
        {DateService.convertDateTimeToString(value.uploadedDate)}
      </small>
    </li>
  );
};

const ExampleFiles = ({ values }) => {
  if (values.length === 0) return;

  return (
    <div className="dropdown mb-3 text-right">
      <button
        className="btn btn-link dropdown-toggle"
        type="button"
        data-toggle="dropdown"
        aria-expanded="false"
      >
        Example Files
      </button>
      <div className="dropdown-menu">
        {values.map((file) => (
          <a
            key={file._id}
            className="dropdown-item"
            target="_blank"
            href={file.url}
          >
            {file.name}
          </a>
        ))}
      </div>
    </div>
  );
};

const JobDocument = ({
  item,
  itemIndex,
  onHandlePreview,
  disabled,
  onFileChange,
}) => {
  const key = `key_${item.key}`;
  const assets = item.values.assetsPreview ?? [];
  const exampleFiles = item.values.exampleFiles ?? [];
  const isComplete = assets.length > 0 ? true : false;

  return (
    <>
      <a
        className={`btn ${
          isComplete ? "btn-primary" : "btn-warning"
        } btn-block text-left py-3`}
        data-toggle="collapse"
        href={`#${key}`}
        role="button"
        aria-expanded="false"
        aria-controls={`${key}`}
      >
        {isComplete ? (
          <i className="fa fa-check-circle-o mr-1" aria-hidden="true" />
        ) : (
          <i className="fa fa-circle-o mr-1" aria-hidden="true" />
        )}{" "}
        {item.values.name} ({assets.length} files){" "}
      </a>
      <div className="row">
        <div className="col">
          <div
            className={`collapse ${isComplete ? "" : "show"} multi-collapse`}
            id={`${key}`}
          >
            <div
              className="card card-body d-block"
              style={{ minHeight: "100px" }}
            >
              <ExampleFiles values={exampleFiles} />
              {isComplete && (
                <ul className="list-unstyled">
                  {assets.map((asset, assetIndex) => {
                    return (
                      <AssetBox
                        key={asset._id}
                        value={asset}
                        disabled={disabled}
                        onFileDelete={() =>
                          onHandlePreview(itemIndex, assetIndex, true)
                        }
                        onFileRollback={() =>
                          onHandlePreview(itemIndex, assetIndex, false)
                        }
                      />
                    );
                  })}
                </ul>
              )}
              {disabled === false && (
                <FileInput
                  field={{
                    name: `assets_${itemIndex}`,
                    type: "file",
                    multiple: true,
                    disabled: disabled,
                  }}
                  onChange={(d) => {
                    onFileChange(itemIndex, d);
                  }}
                ></FileInput>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default forwardRef(function JobDocuments(
  { values = [], disabled = false, onFileChange, onChange, isLoading },
  ref
) {
  if (isLoading === true || values.length === 0) return <NoRecordsFound />;

  const onHandlePreview = (itemIndex, assetIndex, isDelete = true) => {
    const newValues = values.map((value, valueIndex) => {
      if (valueIndex === itemIndex) {
        value.values.assetsPreview = value.values.assetsPreview.map(
          (asset, aIndex) =>
            aIndex === assetIndex ? { ...asset, isDelete: isDelete } : asset
        );

        return { ...value };
      }

      return value;
    });

    onChange(newValues);
  };

  return (
    <div className="col-12">
      {values?.map((item, itemIndex) => (
        <JobDocument
          key={itemIndex}
          item={item}
          itemIndex={itemIndex}
          onHandlePreview={onHandlePreview}
          disabled={disabled}
          onFileChange={onFileChange}
        />
      ))}
    </div>
  );
});
